module.exports = __webpack_public_path__ + "img/guidemap.66b92569.jpg";